<template>
  <div class="full-height">
    <div
      :class="{
        simpleButtons: rowButtons,
        crudButtons: !rowButtons,
        cleanLayout: cleanLayout,
      }"
      class="row container q-px-sm"
    >
      <div class="fit">
        <q-card class="q-px-sm card-crud">
          <q-card-section class="q-py-sm card-title">
            <div class="crud-title">
              <translate>SEARCH_RESULT</translate>
            </div>
          </q-card-section>
          <q-card-section class="q-pb-lg card-table">
            <contract-data-table
              v-if="nmInterface"
              ref="jtDataTable"
              class="table-crud"
              :buttons="datatable.buttons"
              :buttons-filter="filterButtons"
              :fields="datatable.columns"
              :extra-params="extraParam"
              :default-http-options="defaultHttpOptions"
              :nm-interface="nmInterface"
              noneselect
              :row-buttons="rowButtons"
              @selection="selection"
              @action-button="realizaAcao"
              @show-message="showMessage"
            />
            <jt-data-grid-subtitle
              :subtitles="subtitles"
            />
          </q-card-section>
        </q-card>
      </div>
    </div>

    <ModalContractAdditiveOrRenovation :flModal="flModal" @adicionarAditivo="adicionarAditivo" @renovarContrato="renovarContrato" @fecharModal="flModal=false">
    </ModalContractAdditiveOrRenovation>

      <q-dialog v-if="flModalAditivo" v-model="flModalAditivo" maximized>
        <q-layout view="Lhh lpR fff" container class="bg-white modal-medium">
          <q-header class="bg-primary">
            <q-toolbar>
              <q-toolbar-title>{{ $gettext('CONTRACT_ADDITIVE') }}</q-toolbar-title>
              <q-btn v-close-popup flat round dense size="1.5em" icon="cancel" @click="flModalAditivo=false" />
            </q-toolbar>
          </q-header>
          <q-page-container class="card-container-modal">
            <ContractRegisterPage :isAditive="true" :isRenovation="false" :contratoAditivoRenovacao="contractSelected" @confirmAdditive="confirmAdditive"></ContractRegisterPage>
          </q-page-container>
        </q-layout>
      </q-dialog>

      <q-dialog v-if="flModalRenovacao" v-model="flModalRenovacao" maximized>
        <q-layout view="Lhh lpR fff" container class="bg-white modal-medium">
          <q-header class="bg-primary">
            <q-toolbar>
              <q-toolbar-title>{{ $gettext('CONTRACT_RONAVATION') }}</q-toolbar-title>
              <q-btn v-close-popup flat round dense size="1.5em" icon="cancel" @click="flModalRenovacao=false" />
            </q-toolbar>
          </q-header>
          <q-page-container class="card-container-modal">
            <ContractRegisterPage :isAditive="false" :isRenovation="true" :contratoAditivoRenovacao="contractSelected" @confirmRenovation="confirmRenovation"></ContractRegisterPage>
          </q-page-container>
        </q-layout>
      </q-dialog>
  </div>
</template>
<script>
import { Component, Vue } from 'vue-property-decorator'
import { JtCrud } from 'jtech-webcomps'
import { repository, messageBox } from 'jtech'
import ContractDataTable from './ContractDataTable'
import JtDataGridSubtitle from '../../components/jt-data-grid-subtitle/JtDataGridSubtitle'
import ContractRegisterPage from './ContractRegisterPage.vue'
import contractRepository from '../contract/ContractRepository'
import ModalContractAdditiveOrRenovation from './ModalContractAdditiveOrRenovation'
import ServiceTypeContants from './ServiceTypeContants'
const { pageTable } = JtCrud

@Component({
  mixins: [pageTable],
  name: 'ContractPageTable',
  components: { ContractDataTable, JtDataGridSubtitle, ContractRegisterPage, ModalContractAdditiveOrRenovation }
})
class ContractPageTable extends Vue {
  acaoAditivoRenovacao = 'contract.gerenciarAditivoRenovacao';
  flModal = false;
  flModalAditivo = false;
  flModalRenovacao = false;
  contractSelected = null;

  refresh () {
    this.$refs?.jtDataTable?.refresh()
  }

  updated () {
    this.refresh()
  }

  adicionarAditivo () {
    this.flModal = false
    this.flModalAditivo = true
  }

  confirmAdditive (contract) {
    contractRepository.saveContractAdditive(this.formToContract(contract)).then(resContract => {
      messageBox.success(this.$gettext('ADDITIVE_SAVED'))
      this.flModal = false
      this.flModalAditivo = false
      this.refresh()
    }).catch(err => {
      messageBox.error(this.$gettext('ADDITIVE_NOT_SAVED'))
      console.error(err)
    })
  }

  confirmRenovation (contract) {
    contractRepository.saveContractRenovation(this.formToContract(contract)).then(resContract => {
      messageBox.success(this.$gettext('RENOVATION_SAVED'))
      this.flModal = false
      this.flModalRenovacao = false
      this.refresh()
    }).catch(err => {
      messageBox.error(this.$gettext('RENOVATION_NOT_SAVED'))
      console.error(err)
    })
  }

  getUnitMeasureType (contractItem) {
    if (contractItem && contractItem.unitMeasureType) {
      switch (contractItem.unitMeasureType) {
        case ServiceTypeContants.TONNE:
          return this.$gettext('TONNE_LABEL')
        case ServiceTypeContants.KILOGRAM:
          return this.$gettext('KILOGRAM_LABEL')
        case ServiceTypeContants.UNITY:
          return this.$gettext('UNITY_LABEL')
        case ServiceTypeContants.TRIP:
          return this.$gettext('TRIP_LABEL')
        case ServiceTypeContants.BUCKET:
          return this.$gettext('BUCKET_LABEL')
        default:
          return contractItem.unitMeasureTypeText
      }
    }
    return null
  }

  getServiceType (service) {
    if (service && service.serviceType) {
      switch (service.serviceType) {
        case ServiceTypeContants.WASTE_COLLECTION:
          return this.$gettext('WASTE_COLLECTION_LABEL')
        case ServiceTypeContants.FINAL_DESTINATION:
          return this.$gettext('DESTINATION_LABEL')
        case ServiceTypeContants.RCC:
          return this.$gettext('RCC_LABEL')
        case ServiceTypeContants.SHIPPING:
          return this.$gettext('SHIPPING_LABEL')
        case ServiceTypeContants.VALORIZATION:
          return this.$gettext('VALORIZATION_LABEL')
        case ServiceTypeContants.ETE:
          return this.$gettext('ETE_LABEL')
        case ServiceTypeContants.AUTOCLAVE:
          return this.$gettext('AUTOCLAVE_LABEL')
        case ServiceTypeContants.CONTRACT_MAINTENANCE:
          return this.$gettext('CONTRACT_MAINTENANCE_LABEL')
        case ServiceTypeContants.RECEIPT_VALORIZATION:
          return this.$gettext('RECEIPT_VALORIZATION_LABEL')
        case ServiceTypeContants.WEIGHING_SERVICE:
          return this.$gettext('WEIGHING_SERVICE_LABEL')
        case ServiceTypeContants.TWM_SERVICE:
          return this.$gettext('TWM_SERVICE_LABEL')
        case ServiceTypeContants.HORIZONTAL_BALING_PRESS:
          return this.$gettext('HORIZONTAL_BALING_PRESS_LABEL')
        case ServiceTypeContants.WEIGHING_AND_TRACEABILITY_PROJECT:
          return this.$gettext('WEIGHING_AND_TRACEABILITY_PROJECT_LABEL')
        case ServiceTypeContants.EFFLUENT_WATER_TREATMENT:
          return this.$gettext('EFFLUENT_WATER_TREATMENT_LABEL')
        default:
          return service.serviceTypeText
      }
    }

    return null
  }

  todayDateString () {
    const date = new Date()
    const year = date.getFullYear()
    const month = String(date.getMonth() + 1).padStart(2, '0')
    const day = String(date.getDate()).padStart(2, '0')
    return `${year}-${month}-${day}`
  }

  formatDateString (date) {
    if (date.includes('/')) {
      const arrDate = date.split('/')
      return arrDate[2] + '-' + arrDate[1] + '-' + arrDate[0]
    }
    return date
  }

  getContractBirth (date) {
    const arrDate = date.split('/')
    const year = Number(arrDate[2]) + 1
    return year + '-' + arrDate[1] + '-' + arrDate[0]
  }

  generateContractItemRequestObject (contract, service, contractItem) {
    return {
      unitPrice: contractItem.unitPrice?.toString().replaceAll('.', '').replace(',', '.'),
      unitMeasureType: this.getUnitMeasureType(contractItem),
      treatmentType: null,
      totalValueItem: null,
      serviceType: this.getServiceType(service),
      reajustmentIndex: contractItem.readjustmentIndexText,
      productId: contractItem.product,
      productGroupDescription: '',
      productDescription: contractItem.productText,
      mtr: false,
      minimumBilling: contractItem.minimalBilling?.toString().replaceAll('.', '').replace(',', '.'),
      measurementStart: service.measurementStart?.toString().replaceAll('.', '').replace(',', '.'),
      landfillTax: 0.0,
      landfill: contractItem.landfill,
      globalDescription: null,
      globalCode: null,
      contractBidQuantity: contractItem.contractBidQuantity?.toString().replaceAll('.', '').replace(',', '.'),
      classType: contractItem.residueTypeText,
      billingMeasurementType: service.billingMeasurementTypeText,
      billForType: true,
      invertedWeighing: contractItem.invertedWeighing,
      excessValue: contractItem.excessValue?.toString().replaceAll('.', '').replace(',', '.'),
      quantityUpTo: contractItem.quantityUpTo?.toString().replaceAll('.', '').replace(',', '.'),
      useEnvironmentalWeightForBilling: contractItem.useEnvironmentalWeightForBilling,
      carrier: contractItem?.carrier,
      destination: contractItem?.destination,
      billingType: contractItem.contractBillingType?.toString(),
      contractItemBilling: (contractItem.contractItemBilling || []).map(cib => ({
        quantity: cib.quantity,
        value: cib.value.toString().replaceAll('.', '').replace(',', '.'),
        contractItemBillingType: cib.contractItemBillingType
      }))
    }
  }

  generateContractItems (contract) {
    const contractItemsRequest = []
    contract.services.forEach(service => {
      service.contractItems.forEach(contractItem => {
        contractItemsRequest.push(this.generateContractItemRequestObject(contract, service, contractItem))
      })
    })
    return contractItemsRequest
  }

  formToContract (contract) {
    const contractRequest = {
      totalValue: null,
      startOperation: this.formatDateString(contract.startOperation),
      readjustmentDate: this.formatDateString(contract.readjustmentDate),
      paymentInstrument: contract.paymentInstrumentText,
      paymentConditionCode: contract.paymentCondition,
      minimumBilling: contract.minimalBilling.toString().replaceAll('.', '').replace(',', '.'),
      justification: contract.justification,
      contractStart: this.formatDateString(contract.contractStart),
      contractRootNumber: contract.contractRootNumber,
      contractNumber: contract.contractNumberCrm,
      contractItem: this.generateContractItems(contract),
      contractId: contract.id,
      contractEnd: this.formatDateString(contract.contractEnd),
      contractBirth: this.formatDateString(contract.contractStart),
      companyId: null,
      collectionPoint: [],
      clientDocument: null,
      blockIfOverdue: contract.blockIfOverdue,
      alterationDate: new Date(),
      additiveNumber: contract.additiveNumber,
      originOfIntegration: '20440001'
    }
    return contractRequest
  }

  renovarContrato () {
    this.flModal = false
    this.flModalRenovacao = true
  }

  async realizaAcao (button, row) {
    if (button.action === this.acaoAditivoRenovacao) {
      await repository.resolve('contract.gerenciarAditivoRenovacao')
      if (!row.available) {
        messageBox.error(this.$gettext('ADDITIVE_RENOVATION_UNAVAILABLE_ERROR'))
        return
      }
      const contract = await repository.resolve('contract.alterar', { id: row.id })
      this.contractSelected = contract[0].dadosForm
      this.contractSelected.id = row.id
      this.flModal = true
    } else {
      this.actionButton(button, row)
    }
  }

  subtitles = [
    {
      name: 'CONTRACT_SUB_GENERATORS',
      colSize: 8,
      options: [
        {
          name: 'CONTRACT_SUB_GENERATORS_WARNING',
          classLegendColor: 'red',
          icon: 'report_problem'
        },
        {
          name: 'CONTRACT_SUB_GENERATORS_OK',
          classLegendColor: 'green',
          icon: 'check_circle'
        }
      ]
    }
  ];
}
export default ContractPageTable
</script>
<style lang="stylus" scoped>
@import '~quasar-variables';

.modal-replicate-container {
  padding: 10px;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  height: 200px;
}
.replicate-title {
  font-size: 14pt;
  padding-bottom: 10px;
}
.replicate-content {
  text-align: center;
}
.modal-small {
  height: 300px !important;
  max-height: 300px !important;
  min-height: 300px !important;
  width: 500px !important;
  max-width: 500px !important;
  min-width: 500px !important;
}
.margin8 {
  margin: 8px
}
</style>
